import { JsonObject, JsonProperty } from 'json2typescript';

import { LearnCertType } from './learn-cert-type';
import { LearnCertClass } from './learn-cert-class';

@JsonObject
export class LearnCertClassDTO {
  @JsonProperty('learnCertClass', LearnCertClass, true)
  learnCertClass: LearnCertClass = undefined;

  @JsonProperty('learnCertTypes', [LearnCertType], true)
  learnCertTypes: LearnCertType[] = undefined;

  getTypeById(id: number) {
    return this.learnCertTypes.filter(type => type.id === id)[0];
  }
}
